import { ReactNode, useState } from 'react'
import Header from './Header'
import PrinterSettingsModal from './PrinterSettingsModal'
import { useAuth } from '../hooks/useAuth'
import { useExchange } from '../hooks/useExchange'

interface ContainerProps {
  children: ReactNode
}

function Container({ children }: ContainerProps) {
  const { user, selectedBranch, logout } = useAuth()
  const { ratesLastUpdated, isLoadingRates } = useExchange()
  const [showSettings, setShowSettings] = useState(false)

  return (
    <div className="flex flex-col h-screen">
      <Header
        branchName={selectedBranch?.name || '브랜치 미선택'}
        userName={user?.name || 'Guest'}
        onLogout={logout}
        onSettings={() => setShowSettings(true)}
        ratesLastUpdated={ratesLastUpdated}
        isLoadingRates={isLoadingRates}
      />
      <main className="flex-1 overflow-auto">
        {children}
      </main>

      <PrinterSettingsModal
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
      />
    </div>
  )
}

export default Container
